import { FC } from 'react'

import { Box, Typography } from '@mui/material'

interface Props {

}

export const Forbidden: FC<Props> = () => {
    return (
        <Box
            sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <Typography variant='h2' component="span" align="center" >¡Lo Sentimos!</Typography>
            <Typography variant='h5' component="span" align="center">No tienes acceso a esta aplicación.</Typography>
        </Box>
    )
}
